var map = {
	"./1.png": 383,
	"./10 - Copy.png": 1468,
	"./10.png": 486,
	"./11.png": 487,
	"./12.png": 488,
	"./13.png": 489,
	"./14.png": 490,
	"./15.png": 491,
	"./16.png": 492,
	"./17.png": 493,
	"./18.png": 494,
	"./19.png": 495,
	"./2.png": 384,
	"./20.png": 496,
	"./21.png": 497,
	"./22.png": 498,
	"./24.png": 499,
	"./25.png": 500,
	"./26.png": 278,
	"./27.png": 501,
	"./28.png": 502,
	"./29.png": 503,
	"./31.png": 390,
	"./32.png": 391,
	"./33.png": 215,
	"./34.png": 298,
	"./35.png": 216,
	"./4.png": 385,
	"./5.png": 386,
	"./6.png": 387,
	"./7.png": 388,
	"./8.png": 389,
	"./9.png": 485,
	"./AAVE.png": 1469,
	"./ADA.png": 1470,
	"./ALCRYP.png": 938,
	"./AMZN.png": 1471,
	"./APPL - Copy.png": 1472,
	"./APPL.png": 1473,
	"./AVAX.png": 1474,
	"./BCH.png": 814,
	"./BCM.png": 1475,
	"./BEAM.png": 1476,
	"./BNB.png": 547,
	"./BTC.png": 1477,
	"./BTCB.png": 548,
	"./BTCY.png": 1478,
	"./BUSD.png": 1479,
	"./CAKE.png": 1480,
	"./CHZ.png": 1481,
	"./CRYC10.png": 939,
	"./DAI.png": 815,
	"./DOGE.png": 816,
	"./DOT.png": 817,
	"./DaCrazy.png": 1482,
	"./EPS.png": 1483,
	"./EQSTK.png": 940,
	"./ETH.png": 818,
	"./FTM.png": 1484,
	"./FTT.png": 819,
	"./GOOGL.png": 1485,
	"./IBAT.png": 1486,
	"./IN500.png": 820,
	"./IN500_logo.png": 246,
	"./IN500_old.png": 1487,
	"./INDXXF.png": 941,
	"./INEX-ETH.png": 1488,
	"./INEX-ETHEREUM.png": 1489,
	"./INEX-POLYGON.png": 1490,
	"./INEX.png": 546,
	"./INEX_old.png": 1491,
	"./INJ.png": 1492,
	"./INXC.png": 821,
	"./INXC_logo.png": 247,
	"./INXC_old.png": 1493,
	"./INXP.png": 822,
	"./IUSD+.png": 823,
	"./IUSD+_old.png": 1494,
	"./IUSD.png": 1495,
	"./IUSDP.png": 1496,
	"./IUSDP_logo.png": 200,
	"./LBlock.png": 1497,
	"./LEO.png": 824,
	"./LINK.png": 825,
	"./LTC.png": 826,
	"./MANA.png": 1498,
	"./MATIC.png": 827,
	"./META.png": 1499,
	"./MSFT.png": 1500,
	"./NEAR.png": 1501,
	"./NOT.png": 1502,
	"./NVDA.png": 1503,
	"./PEP.png": 1504,
	"./PYTH.png": 1505,
	"./RUNE.png": 1506,
	"./SHIB.png": 828,
	"./SNP500.png": 1507,
	"./SOL.png": 829,
	"./SPX.png": 1508,
	"./SUI.png": 1509,
	"./THETA.png": 1510,
	"./TLSA.png": 1511,
	"./TOB.png": 942,
	"./TON.png": 830,
	"./TRX.png": 831,
	"./TSLA.png": 1512,
	"./TUSD.png": 549,
	"./USD.png": 161,
	"./USDC.png": 832,
	"./USDT.png": 1513,
	"./VET.png": 1514,
	"./WIBS.png": 833,
	"./WIBS_1.png": 1515,
	"./XLM.png": 1516,
	"./XRP.png": 834,
	"./_IUSD.png": 1517,
	"./eth new PP lpgo 1.png": 1518,
	"./inxf.png": 1519,
	"./old/ALCRYP.png": 1520,
	"./old/AMZN.png": 1521,
	"./old/APPL.png": 1522,
	"./old/BCM.png": 1523,
	"./old/CRYC10.png": 1524,
	"./old/EQSTK.png": 1525,
	"./old/GOOGL.png": 1526,
	"./old/IN500.png": 1527,
	"./old/IN500_logo.png": 1528,
	"./old/INDXXF.png": 1529,
	"./old/INEX.png": 1530,
	"./old/INXC.png": 1531,
	"./old/INXC_logo.png": 1532,
	"./old/IUSD.png": 1533,
	"./old/META.png": 1534,
	"./old/MSFT.png": 1535,
	"./old/NVDA.png": 1536,
	"./old/PEP.png": 1537,
	"./old/SNP500.png": 1538,
	"./old/TLSA.png": 1539,
	"./old/TOB.png": 1540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;